import DateIdentifier from '@/helper-classes/inspector/DateIdentifier';

export default class DateInfo {
  startDateID: DateIdentifier;
  endDateID: DateIdentifier;
  prices: number[] = [];
  volume: number = 0;
  pixelStart: number;
  percentChange: number | null = null;

  constructor(rawDateDataString: string) {
    const rawDateDataArray = rawDateDataString.split(' ');
    this.pixelStart = parseInt(rawDateDataArray[0], 10);

    // Start date is the one primarily used
    this.startDateID = new DateIdentifier(rawDateDataArray[1]);
    this.endDateID = new DateIdentifier(rawDateDataArray[2]);

    if (rawDateDataArray.length === 8) {
      // o, h, l, c, v
      this.prices.push(parseFloat(rawDateDataArray[3]));
      this.prices.push(parseFloat(rawDateDataArray[4]));
      this.prices.push(parseFloat(rawDateDataArray[5]));
      this.prices.push(parseFloat(rawDateDataArray[6]));
      this.volume = parseFloat(rawDateDataArray[7]);
      return;
    }

    if (rawDateDataArray.length === 5) {
      // Just close values
      this.prices.push(parseFloat(rawDateDataArray[3]));
      this.prices.push(parseFloat(rawDateDataArray[3]));
      this.prices.push(parseFloat(rawDateDataArray[3]));
      this.prices.push(parseFloat(rawDateDataArray[3]));
      this.volume = parseFloat(rawDateDataArray[4]);
    }
  }

  public getPrices() {
    return [
      this.prices[0],
      this.prices[1],
      this.prices[2],
      this.prices[3]
    ];
  }
}
